module.exports = __webpack_public_path__ + "img/alliancebg.891bee93.png";